import { ConfigurationsService } from '@/services';
import { writable } from 'svelte/store';
const initialState = [];
const store = writable(initialState);
const actions = {
    getAll: async () => {
        const configurations = await new ConfigurationsService().getAll();
        store.set(configurations);
    },
    getByIdAndType: async (type, name) => {
        const configuration = await new ConfigurationsService().getByIdAndType(type, name);
        return configuration;
    },
    create: async (configuration) => {
        await new ConfigurationsService().create(configuration);
        await actions.getAll();
    },
    remove: async (type, name) => {
        await new ConfigurationsService().deleteByIdAndType(type, name);
        await actions.getAll();
    }
};
export const configurationsStore = {
    subscribe: store.subscribe,
    ...actions
};
export default configurationsStore;
